import styled from "styled-components";
import AppTheme from "../../../AppTheme.styled";

const StyledSearchInput = styled.div`
  position: relative;
  width: 100%;
`;

export const selectStyles = {
  option: (styles: any, state: any) => ({
    ...styles,
    padding: "7px 15px",
    cursor: "pointer",
    ":active": {
      ...styles[":active"],
      backgroundColor:
        !state.isDisabled &&
        (state.isSelected
          ? AppTheme.palette.primary
          : AppTheme.palette.background3),
    },
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    borderRadius: 10,
    backgroundColor: "transparent",
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 4,
    borderRadius: 10,
    overflow: "hidden",
  }),
  menuList: (provided: any, state: any) => ({
    ...provided,
    padding: "7px 0",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: 16,
    lineHeight: "160%",
    color: AppTheme.palette.neutral3,
  }),
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    padding: state.selectProps.small ? "6px 15px" : "15px",
  }),
  singleValue: (provided: any, state: any) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const color = AppTheme.palette.neutral1;
    return { ...provided, opacity, color };
  },
};

export default StyledSearchInput;
